import api from "./api.js";
// import axios from "axios";

export default {
  getInfo(payload) {
    return api.get("/shop?username=" + payload);
  },
  updatePackage(data) {
    return api.post("/package/update", data);
  },
  updatePackageVn(data) {
    return api.post("/package/updateVn", data);
  }
};
